<template>
  <div class="extparam">
    <div v-for="(items,index) in extparams.parameter" :key="index">
<van-field v-if="items.name!='charge_num'" v-model="extParam[items.name]" :label="items.title" :placeholder="items.title" />
<div class="change_unm" v-if="items.name=='charge_num'">
   <div class="input-box enum" v-if="items.enum.length>0">
      <van-field
        readonly
        clickable
        :label="items.title"
        :value="extParam[items.name]"
        :placeholder="'请选择' + items.title"
        right-icon="arrow"
        @click="showPickerEnum = true"
      />
      <Popup :title="items.title"  :columns="items.enum" :showPicker="showPickerEnum" @selecteValue="selelctChargeNum" @closePop="closePop"></Popup>
  </div>
  <div class="input-box range" v-if="items.range[0].length>0&items.enum.length==0">
    <span>{{items.title}}</span>
    <span>可输入范围{{items.range[0][0]}}-{{items.range[0][1]}}</span>
    <van-stepper :min="items.range[0][0]" :max="items.range[0][1]" integer v-model="extParam[items.name]" />
  </div>
  <div v-if="extparams.game_list.length > 0">
          <van-field
            v-model="extParam['charge_game_name']"
            is-link
            readonly
            name="picker"
            label="选择游戏"
            placeholder="点击选择游戏"
            @click="game.gamePicker = true"
          />
          <Popup :title="items.title"  :columns="items.enum" :showPicker="showPickerGameName" @selecteValue="selelctGameName" @closePop="closePop"></Popup>
          <!-- <van-popup v-model:show="game.gamePicker" position="bottom">
            <van-picker
              :columns="game.gameList"
              value-key="game_name"
              :show-toolbar="true"
              @confirm="gameConfirm"
              @cancel="game.gamePicker = false"
            />
          </van-popup> -->
  </div>
   <!-- <div v-if="game.gameList.length > 0">
          <van-field
            v-model="extParams['charge_game_name']"
            is-link
            readonly
            name="picker"
            label="选择游戏"
            placeholder="点击选择游戏"
            @click="game.gamePicker = true"
          />
          <van-popup v-model:show="game.gamePicker" position="bottom">
            <van-picker
              :columns="game.gameList"
              value-key="game_name"
              :show-toolbar="true"
              @confirm="gameConfirm"
              @cancel="game.gamePicker = false"
            />
          </van-popup>
        </div>

        <div v-if="game.gameRegionServer.length > 0">
          <van-field
            v-model="game.gameRegionServerText"
            is-link
            readonly
            name="picker"
            label="选择游戏区服"
            placeholder="点击选择游戏区服"
            @click="game.gameRegionServerPicker = true"
          />
          <van-popup v-model:show="game.gameRegionServerPicker" position="bottom">
            <van-picker
              :columns="game.gameRegionServer"
              value-key="text"
              :show-toolbar="true"
              @confirm="gameRegionServerConfirm"
              @cancel="game.gameRegionServerPicker = false"
            />
          </van-popup>
        </div>

        <div v-if="game.chargetype.length > 0">
          <van-field
            v-model="extParams['charge_type']"
            is-link
            readonly
            name="picker"
            label="选择充值方式"
            placeholder="点击选择充值方式"
            @click="game.chargetypePicker = true"
          />
          <van-popup v-model:show="game.chargetypePicker" position="bottom">
            <van-picker
              :columns="game.chargetype"
              :show-toolbar="true"
              @confirm="chargetypePickerConfirm"
              @cancel="game.chargetypePicker = false"
            />
          </van-popup>
        </div> -->
        <!-- <div v-if="game.gameList.length > 0">
          <van-field
            v-model="extParams['charge_game_name']"
            is-link
            readonly
            name="picker"
            label="选择游戏"
            placeholder="点击选择游戏"
            @click="game.gamePicker = true"
          />
          <van-popup v-model:show="game.gamePicker" position="bottom">
            <van-picker
              :columns="game.gameList"
              value-key="game_name"
              :show-toolbar="true"
              @confirm="gameConfirm"
              @cancel="game.gamePicker = false"
            />
          </van-popup>

  </div> -->
 <!-- <van-field  v-model="extParam[items.name]" :label="items.title" :placeholder="items.title" /> -->

</div>


     </div>
  </div>
</template>

<script>
import Popup from "@/components/popup.vue";
export default {
  props: {
    extparams: {
      default: {},
      type: Object
    },
    game: {
      default: {},
      type: Object
    }
  },
  components: {
    Popup
  },
  data() {
    return {
      stepper: "",
      value: "",
      extParam: {},
      showPickerEnum: false,
      gameList: []
    };
  },
  methods: {
    // tt() {
    //   console.log(this.extParam);
    // }
    slecteExtParams() {
      console.log(this.extparams.parameter);
      this.extparams.parameter.forEach((val, index, arr) => {
        console.log(val.name);
        this.extParam[val.name] = " ";
      });

      //游戏充值
      if (this.extparams.game_list & (this.extparams.game_list.length > 0)) {
        this.gameList = this.extparams.game_list;
      }
      console.log(this.extParam);
    },
    //选择数量
    selelctChargeNum(value, showPickerEnum) {
      console.log(value);
      this.extParam["charge_num"] = value;
      this.showPickerEnum = showPickerEnum;
      // this.$emit("change_num",value)
    },

    closePop(value) {
      this.showPickerEnum = value;
    }
  },
  mounted() {
    this.slecteExtParams();

    // this.tt();
    // console.log(this.extParam)
  }
};
</script>

<style lang="less" >
.extparam {
  padding: 8px 16px;
  margin-top: 0.2rem;
  background: #fff;
  .van-field {
    border-bottom: solid 1px #eee;
    padding: 0.2rem 0rem !important;
  }
  .input-box {
    width: 100%;
    display: flex;
    margin-bottom: 0.1rem;
    justify-content: space-between;
    padding: 0.2rem 0rem;
    .van-stepper {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/extParam.vue